import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import InlineSvg from './inline_svg';

export default function ExternalSvg({ src, width, height }) {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(src)
      .then((response) => response.text())
      .then(setContent)
      .catch(() => {});
  }, [src]);

  return (
    <InlineSvg width={width} height={height}>
      {content}
    </InlineSvg>
  );
}

ExternalSvg.propTypes = {
  height: PropTypes.number,
  src: PropTypes.string,
  width: PropTypes.number,
};
